var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProportionalArrowSingleCurvedModeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2.5c6.075 0 11 3.582 11 8s-4.925 8-11 8c-.789 0-1.558-.06-2.3-.175-1.851 1.413-3.56 2.4-5.126 2.96l-.338.115a.5.5 0 0 1-.64-.587c.4-1.696.681-3.197.842-4.504C2.32 14.851 1 12.788 1 10.5c0-4.418 4.925-8 11-8zm0 1.38c-5.39 0-9.62 3.076-9.62 6.62 0 1.74 1.012 3.414 2.84 4.672l.69.475-.102.83a37.164 37.164 0 0 1-.392 2.443l-.112.56.063-.03c.974-.477 2.016-1.124 3.124-1.943l.372-.279.467-.357.581.09c.68.105 1.38.159 2.089.159 5.39 0 9.62-3.076 9.62-6.62S17.39 3.88 12 3.88zm5.111 2.165 3.026 5.987-6.605-1.172 1.351-1.817c-3.661-1.427-7.048.119-8.958 4.111l-1.172-.56c2.266-4.739 6.52-6.521 10.929-4.627l1.43-1.922z",
  fill: "#1500FF"
}))));
export default SvgProportionalArrowSingleCurvedModeIcon;